import { formatDateYYYYMMDD } from "../../../../helpers/date";
import moment from "moment";
const MODULE_NAME = "oncall/";

// actions
export const SCHEDULE_PAGE_LOAD = `@@${MODULE_NAME}SCHEDULE_PAGE_LOAD`;
export const SHIFTS_DEFINITIONS_LOADED = `@@${MODULE_NAME}SHIFTS_DEFINITIONS_LOADED`;
export const SHIFT_DEFINITION_CLICKED = `@@${MODULE_NAME}SHIFT_DEFINITION_CLICKED`;

export const REQUEST_CREATE_SHIFT_DEFINITION = `@@${MODULE_NAME}REQUEST_CREATE_SHIFT_DEFINITION`;
export const REQUEST_UPDATE_SHIFT_DEFINITION = `@@${MODULE_NAME}REQUEST_UPDATE_SHIFT_DEFINITION`;
export const REQUEST_MOVE_SHIFT_DEFINITION = `@@${MODULE_NAME}REQUEST_MOVE_SHIFT_DEFINITION`;
export const REQUEST_DELETE_SHIFT_DEFINITION = `@@${MODULE_NAME}REQUEST_DELETE_SHIFT_DEFINITION`;

export const SHIFT_DEFINITION_CREATED = `@@${MODULE_NAME}SHIFT_DEFINITION_CREATED`;
export const SHIFT_DEFINITION_UPDATED = `@@${MODULE_NAME}SHIFT_DEFINITION_UPDATED`;
export const SHIFT_DEFINITION_MOVED = `@@${MODULE_NAME}SHIFT_DEFINITION_MOVED`;
export const SHIFT_DEFINITION_DELETED = `@@${MODULE_NAME}SHIFT_DEFINITION_DELETED`;

export const SHIFT_DEFINITION_ERROR = `@@${MODULE_NAME}SHIFT_DEFINITION_ERROR`;

// creators
export const shiftsDefinitionsPageLoad = regionId => ({
  type: SCHEDULE_PAGE_LOAD,
  payload: {
    regionId,
  },
});

export const shiftsDefinitionsLoaded = shiftsDefinitions => ({
  type: SHIFTS_DEFINITIONS_LOADED,
  payload: {
    shiftsDefinitions,
  },
});

export const shiftDefinitionClicked = shiftDefinition => ({
  type: SHIFT_DEFINITION_CLICKED,
  payload: {
    shiftDefinition,
  },
});

export const requestCreateShiftDefinition = (
  calendarShiftDefinition,
  regionId,
) => ({
  type: REQUEST_CREATE_SHIFT_DEFINITION,
  payload: {
    regionId: regionId,
    engineerId: calendarShiftDefinition.engineer.id,
    startDate: calendarShiftDefinition.start,
    priority: calendarShiftDefinition.priority,
  },
});

// intervalStart and intervalEnd are javascript Date objects
function dateDiffInDays(intervalStart, intervalEnd) {
  const startOfDayA = moment(intervalStart).startOf("day");
  const startOfDayB = moment(intervalEnd).startOf("day");
  return startOfDayB.diff(startOfDayA, "days");
}

export const requestUpdateShiftDefinition = (
  id,
  startDate,
  endDate,
  priority,
) => ({
  type: REQUEST_UPDATE_SHIFT_DEFINITION,
  payload: {
    id,
    startDate: formatDateYYYYMMDD(startDate),
    startTime: `${moment(startDate).format("HH:mm")}:00`,
    days: dateDiffInDays(startDate, endDate),
    endTime: `${moment(endDate).format("HH:mm")}:00`,
    priority: priority,
  },
});

export const requestMoveShiftDefinition = (id, startDate) => ({
  type: REQUEST_MOVE_SHIFT_DEFINITION,
  payload: {
    id,
    startDate: formatDateYYYYMMDD(startDate),
  },
});

export const requestDeleteShiftDefinition = id => ({
  type: REQUEST_DELETE_SHIFT_DEFINITION,
  payload: {
    id,
  },
});

export const shiftDefinitionCreated = shiftDefinition => ({
  type: SHIFT_DEFINITION_CREATED,
  payload: {
    shiftDefinition,
  },
});

//noinspection OverlyComplexFunctionJS
export const shiftDefinitionUpdated = (
  oldId,
  newId,
  startDate,
  startTime,
  days,
  endTime,
  priority,
) => ({
  type: SHIFT_DEFINITION_UPDATED,
  payload: {
    oldId,
    newId,
    startDate,
    startTime,
    days,
    endTime,
    priority,
  },
});

export const shiftDefinitionMoved = (oldId, newId, startDate) => ({
  type: SHIFT_DEFINITION_MOVED,
  payload: {
    oldId,
    newId,
    startDate,
  },
});

export const shiftDefinitionDeleted = id => ({
  type: SHIFT_DEFINITION_DELETED,
  payload: {
    id,
  },
});

export const shiftDefinitionError = message => ({
  type: SHIFT_DEFINITION_ERROR,
  payload: {
    message,
  },
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/actions/shifts-definitions.js